/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { withAccount } from '../../../components/AccountContext';
import { ACCOUNTS_IN_HIERARCHY } from './queries';
import apollo from '../../../services/apollo';
import generateTreeNodes from './generateTreeNodes';
import messages from './intl-messages';

const AddRemoveDimensionsOrAbilities = ({ currentAccount }) => {
  const NUMBER_OF_ROWS = 10;
  const EMPTY_DATA_MODEL = {
    rootAccount: {
      assessmentSections: {
        behaviorSection: {
          dimensions: [],
        },
        cognitiveSection: {
          dimensions: [],
        },
        interestsSection: {
          dimensions: [],
        },
      },
    },
    descendantAccounts: [],
    totalNumberOfDescendants: 0,
  };

  const [data, setData] = useState(EMPTY_DATA_MODEL);
  const [isLoading, setIsLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [filter, setFilter] = useState('');

  const { formatMessage } = useIntl();


  const fetchData = async () => {
    setIsLoading(true);

    const variables = {
      id: currentAccount, first, rows: NUMBER_OF_ROWS, filter,
    };

    try {
      const result = await apollo.query({
        query: ACCOUNTS_IN_HIERARCHY,
        variables,
        fetchPolicy: 'no-cache',
      });

      setData(result.data.accountHierarchyForAccountContentManagement);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [first]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(timer);
  }, [filter]);

  const intlMessages = {
    dimensionsActivated: formatMessage(messages.dimensionsActivated),
    distortions: formatMessage(messages.distortions),
    dimensions: formatMessage(messages.dimensions),
    dimensionsActivatedForSection: formatMessage(messages.dimensionsActivatedForSection),
    abilitiesActivated: formatMessage(messages.abilitiesActivated),
    distortionsActivated: formatMessage(messages.distortionsActivated),
    abilitiesActivatedForCompetence: formatMessage(messages.abilitiesActivatedForCompetence),
  };

  const dataIsLoading = isLoading || data === EMPTY_DATA_MODEL;

  const nodes = generateTreeNodes(data, fetchData, intlMessages);

  return (
    <div className="brand-detailed-wrapper">
      <div className="p p-panel p-component manage-account-itembank-content-container">
        <h3 className="manage-account-itembank-content-header">{formatMessage(messages.title)}</h3>
        <TreeTable
          value={nodes}
          loading={dataIsLoading}
          paginator
          lazy
          rows={NUMBER_OF_ROWS}
          first={first}
          totalRecords={data.totalNumberOfDescendants}
          onFilter={(filters) => {
            if (filters.filters.name && filters.filters.name.value) {
              const { filters: { name: { value } } } = filters;

              setFilter(value);
              setFirst(0);
            } else {
              setFilter('');
              setFirst(0);
            }
          }}
          onPage={(event) => {
            setFirst(event.first);
          }}
        >
          <Column
            field="name"
            expander
            filter
            filterPlaceholder={formatMessage(messages.filterAccount)}
          />
          <Column field="status" header={formatMessage(messages.status)} />
        </TreeTable>
      </div>
    </div>
  );
};

AddRemoveDimensionsOrAbilities.propTypes = {
  currentAccount: PropTypes.number.isRequired,
};

export default withAccount(AddRemoveDimensionsOrAbilities);
